import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useVarianceDetails from 'src/hooks/useVarianceDetails';
const VarianceHeaderCell = (props: GridHeaderCellProps) => {
  const { varianceLineItems, setVarianceLineItems } = useVarianceDetails();

  const isAllItemsExpanded = useMemo(
    () => varianceLineItems?.every((lineItem) => lineItem?.expanded),
    [varianceLineItems]
  );

  const handleHeaderCellExpand = useCallback(() => {
    setVarianceLineItems((prev) =>
      [...prev].map((item) => ({ ...item, expanded: !isAllItemsExpanded }))
    );
  }, [isAllItemsExpanded, setVarianceLineItems]);

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllItemsExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};
export default VarianceHeaderCell;
